import React, { Component } from 'react';
import NewsBox from '../NewsBox'
import './newsSlider.css'

class NewsSlider extends Component {

    constructor(props){
	super(props)
	this.state = {
	    currentIndex: 0
	}
    }

    
    
    render() {
	const {news} = this.props
	let {currentIndex} = this.state
	
	const scrollAnimation = (imagesCont, scrollWidth, index, count, duration) => {
	    var direction = null
	    if(count<=duration)
		setTimeout(function(){
		    if(imagesCont.scrollLeft < index*scrollWidth )
			 direction = 1
		    else if(imagesCont.scrollLeft > index*scrollWidth )
			 direction = -1
		    else
			 direction = 0
		    
		    imagesCont.scrollTo((index+direction*-1)*scrollWidth+(scrollWidth*direction*count/duration), 0);
		    scrollAnimation(imagesCont, scrollWidth, index, count+1, duration)   	
		}, 1);
	    
	}

	
	const scrollTo = (index) =>{	    
	    if( this.refs.images.children[0]){
		const clientWidth = this.refs.images.children[0].clientWidth
		
		if(this.refs.images.childElementCount>index+(this.refs.images.clientWidth/clientWidth-1) && index>=0){
		    scrollAnimation(this.refs.images, clientWidth, index, 0, 100)
		    currentIndex = index
		    this.setState({currentIndex})
		}
	    }
	}

	
	
	return (
	    <div className="newsSlider" >
		<div className="row" style={{overflow: 'hidden', flexWrap: 'nowrap'}} ref="images">
		    { news ?
		      news.map((n, index) => {
			  return (<NewsBox key={index} news={n} />)
		      }
		      )
		      :
		      ''
		    }
		</div>
		<div className="actionLeft"><i className="fa fa-angle-left" onClick={() => scrollTo(currentIndex-1)}></i></div>
		<div className="actionRight"><i className="fa fa-angle-right"  onClick={() => scrollTo(currentIndex+1)}></i></div>
	    </div>

	);
    }
}

export default NewsSlider;



// WEBPACK FOOTER //
// ./src/components/NewsSlider/index.jsx